import PropTypes from "prop-types";
import React from "react";
import { MicIcon } from "@fluentui/react-icons-northstar";
import { Button } from "@fluentui/react-northstar";

const FloatingMicButton = ({ isVisible, micPosition, onClick, buttonRef }) => {
  if (isVisible) return null;

  return (
    <Button
      ref={buttonRef}
      circular
      icon={<MicIcon style={{ marginTop: "8px" }} />}
      className="floating-mic-button tour-voice-command"
      onClick={onClick}
      title="Start voice command"
      style={{
        left: micPosition.x,
        top: micPosition.y,
        display: "block",
        visibility: "visible",
      }}
    />
  );
};

FloatingMicButton.propTypes = {
  buttonRef: PropTypes.object,
  isVisible: PropTypes.bool.isRequired,
  micPosition: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

FloatingMicButton.defaultProps = {
  buttonRef: null,
};

export default FloatingMicButton;

